import { render, staticRenderFns } from "./DelegatesViewPage.vue?vue&type=template&id=47297da8"
import script from "./DelegatesViewPage.vue?vue&type=script&lang=ts"
export * from "./DelegatesViewPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports